// extracted by mini-css-extract-plugin
export default {"root":"ProductKind-root_VAG6e"};